import {Grid, Typography} from "@mui/material";
import Tarjeta_Blog_Home from "../Tarjetas/Tarjeta_Blog_Home";
import Tarjeta_Servicios_Home from "../Tarjetas/Tarjeta_Servicios_Home";
import diego from '../../../Recursos/diego.png'
import Lista_Blog from "./SubComponentes/Lista_Blog";

const Blog_Home = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container    justifyContent="flex-start" size={{xs: 12, sm: 12, md: 11}} sx={{maxWidth: 1400, px: 3}}>

                <Grid container
                      justifyContent="flex-start"

                      size={{xs: 12, sm: 12, md: 12}}>
                    <Typography variant='h2'>
                        Blog
                    </Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Lista_Blog/>
                </Grid>
            </Grid>


        </Grid>
    )

}
export default Blog_Home